import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import { PlusIcon } from "@icons";
import styles from "./Board.module.scss";

interface BoardAddButtonProps {
    /** Names the button; it shows only a plus. */
    label: string;
    onClick: () => void;
}

/** `+` beside the column title; adds at the top of the column. */
export const BoardHeaderAddButton = ({
    label,
    onClick,
}: Readonly<BoardAddButtonProps>) => (
    <Button
        variant="secondary"
        size="sm"
        iconOnly
        aria-label={label}
        className={styles.headerAdd}
        onClick={onClick}
    >
        <PlusIcon />
    </Button>
);

/** Full-width `+` bar under the cards; adds at the end of the column. */
export const BoardFooterAddButton = ({
    label,
    onClick,
}: Readonly<BoardAddButtonProps>) => (
    <Button
        variant="primary"
        size="sm"
        block
        aria-label={label}
        leftIcon={<PlusIcon />}
        className={styles.footerAdd}
        onClick={onClick}
    />
);

interface BoardGapAddButtonProps extends BoardAddButtonProps {
    /** `below` is the gap under the last card. */
    edge?: "above" | "below";
}

/**
 * Small `+` centred on the gap above (or below) a card. It sits outside the
 * layout, so cards keep their spacing; it shows while the card next to it is
 * hovered. It's no Tab stop: N and Shift+N on a focused card add there.
 */
export const BoardGapAddButton = ({
    label,
    onClick,
    edge = "above",
}: Readonly<BoardGapAddButtonProps>) => (
    <Button
        variant="primary"
        size="xs"
        iconOnly
        aria-label={label}
        tabIndex={-1}
        className={classNames(styles.gapAdd, {
            [styles.gapAddBelow]: edge === "below",
        })}
        onClick={onClick}
    >
        <PlusIcon />
    </Button>
);
